import { on } from '@ember/modifier';
import { action } from '@ember/object';
import { service } from '@ember/service';
import Component from '@glimmer/component';

import type { Service } from 'webapp-types';

type Args = Record<string, never>;

export default class BillingUnverifiedAgencyWarningComponent extends Component<Args> {
	@service('account') declare accountService: Service.Account;
	@service('user-settings') declare userSettingsService: Service.UserSettings;

	@action
	dismiss(): void {
		this.userSettingsService.hasDismissedUnverifiedAgencyWarning = true;
	}

	<template>
		<div class="notification-container billing-page-notification">
			You signed up for an Agency plan that requires manual activation.
			<a role="button" href={{this.accountService.bookACallLink}} target="_blank">
				Contact support
			</a>
			&nbsp;to get started, or
			<a role="button" {{on "click" this.dismiss}}>dismiss this notice</a>.
		</div>
	</template>
}
